<div class="auth-c-background">
   <div class="auth-c-container mos-u-color-bg--white">
      <div class="auth-c-container__header--container mos-u-color-bg--secondary"
         style="background-image: url('assets/images/auth-container-header-bg.png');">
         <div class="auth-c-container__header row align-center">
            <div class="columns small-12 auth-c-container__header__top-header">
               <div class="auth-c-container__header__top-header--container">
                  <div class="columns small-12 mos-u-color-text--white mos-u-text-center mos-u-font-weight--bold mos-u-spacer--padding-top-xlg auth-c-container__header__top-header--title
                     typographyStyles-body-large">
                     <h1>
                        Mercer Account Center
                     </h1>
                  </div>
                  <div class="auth-c-container__header__top-header--hr"></div>
               </div>
            </div>
            <div class="columns small-12 medium-8 mos-u-color-text--white mos-u-text-center mos-u-spacer--margin-top-lg mos-u-spacer--margin-bottom-xlg auth-c-container__header__top-header--copy
               typographyStyles-body-small">
               <p>
                  Allows you to have a single sign-in solution across all participating Mercer applications.
               </p>
            </div>
         </div>
      </div>
      <div class="auth-c-container__content">
         <div class="row align-center">
            <div class="columns large-9 medium-10 small-12">
               <div
                  class="auth-c-container__content-body--container mos-u-spacer--margin-bottom-xlg mos-u-spacer--margin-left-md mos-u-spacer--margin-right-md">
                  <div container-body="">
                     <div class="mos-u-font-weight--bold auth-c-container__content--title typographyStyles-body-small">


                        <atlas-icon alt="Reset Password" [icon]="'icon-lock-24'" [collection]="'system'"
                           [size]="'large'">
                           <svg class="mos-c-icon mos-c-icon--xlg mos-t-icon--default ng-star-inserted" role="img">
                              <title class="ng-star-inserted">
                                 Reset Password
                              </title>
                              <use xlink:href="#mos-icon-lock"></use>
                           </svg>
                        </atlas-icon>
                        <span>Reset Password</span>

                     </div>
                     <div *ngIf="!(forgotPasswordMailSentStatus$ | async)">
                        <div
                           class="mos-u-font-weight--medium mos-u-spacer--margin-bottom-xlg typographyStyles-body-small">
                           <span>Enter the email address associated with your account.</span>
                        </div>
                        <form novalidate [formGroup]="form" (keyup.enter)="continue()">
                           <div class="row ">
                              <div class="columns small-12 ">
                                 <atlas-field [fullWidth]="true">
                                    <atlas-field-label>Email Address*</atlas-field-label>
                                    <input atlasInput type="text" placeholder="Enter your email address"
                                       [formControl]="form.get('email')">
                                    <atlas-field-error *ngIf="form.get('email').hasError('required')">
                                       <span>Email is required</span>
                                    </atlas-field-error>
                                    <atlas-field-error *ngIf="form.get('email').hasError('email')">
                                       <span>
                                          Please enter a valid Email i.e. email&#64;example.com
                                       </span>
                                    </atlas-field-error>
                                 </atlas-field>
                              </div>
                           </div>
                        </form>
                     </div>
                     <div *ngIf="forgotPasswordMailSentStatus$ | async"
                        class="mos-u-font-weight--medium mos-u-spacer--margin-bottom-xlg">
                        <span *ngIf="forgotPasswordMailSentResponse$ | async">
                           {{forgotPasswordMailSentResponse$ | async}}
                        </span>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
      <div class="auth-c-container__footer ">
         <div class="row">
            <!-- <div class="columns medium-10 small-12"> -->
            <!-- <div class="row mos-u-spacer--margin-top-sm mos-u-spacer--margin-bottom-sm"> -->
            <div class="columns small-12 medium-6 forgot-password-action-col">
               <atlas-button (click)="reset()">
                  Cancel
               </atlas-button>
            </div>
            <div class="columns small-12 medium-6 forgot-password-action-col">
               <atlas-button type="submit" (click)="continue()" [disabled]="form.invalid"
                  [style]="(!form.invalid ) ? 'strong' : 'no-fill'">
                  Continue
               </atlas-button>
            </div>

            <!-- <atlas-button id="button-admin-save-user"
               [disabled]="!(isEnable$ | async) || form.invalid || !canEdit || (canEdit && !isEditing && !isAdding)"
               [style]="((isEnable$ | async) && !form.invalid && canEdit && !(canEdit && !isEditing && !isAdding)) ? 'strong' : 'no-fill'"
               (click)="onSubmit()">Save
            </atlas-button> -->


            <!-- </div> -->
            <!-- </div> -->
         </div>
      </div>
   </div>
</div>